import { IColumns } from '../../../../../../../components/Dashboard/Table'

// export type BankAccountsColumnKeys = 'id' | 'currency' | 'bankName' | 'description' | 'bankFees' | 'actions'

export const columns: IColumns[] = [
  {
    id: 'currency',
    label: 'Currency',
  },
  {
    id: 'bankName',
    label: 'Bank Name',
  },
  {
    id: 'status',
    label: 'Status',
  },
  {
    id: 'actions',
    label: 'ACTIONS',
  },
]
